<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button @click="addCamera" color="primary" type="border" icon-pack="feather" icon="icon-plus">
                        {{ this.$t('news.addNews') }}
                    </vs-button>
                </div>
                <div>
                    <vs-button v-if="isSelected" @click="deleteMulti" color="danger">
                        Xóa lựa chọn
                    </vs-button>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :components="components" :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                :defaultColDef="defaultColDef" :rowData="listNews"
                :localeText="{ noRowsToShow: this.$t('menuCamera.noRowsToShow') }" :animateRows="true"
                :paginationPageSize="paginationPageSize" :onGridReady="onGridReady" :autoSizeStrategy="autoSizeStrategy"
                :suppressRowClickSelection="true" :rowSelection="'multiple'" @row-selected="onRowSelected">
            </ag-grid-vue>

            <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" @change="loadPage" />
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import CellRendererActionsClass from "./cell-renderer/CellRendererActionsClass.vue";
import CellRendererContentClass from "./cell-renderer/CellRendererContentClass.vue";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        AgGridVue,
        // Cell Renderer
        Pagination,
        CellRendererActionsClass,
        CellRendererContentClass,
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('news.humanCreate'),
                    field: 'employeeDetailResponseDTO.fullName',
                    minWidth: 120,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                },
                {
                    headerName: this.$t('news.department'),
                    field: 'departmentResponseDTO.departmentName',
                    width: 170
                },
                {
                    headerName: this.$t('news.title'),
                    field: 'title',
                    width: 120
                },
                {
                    headerName: this.$t('news.content'),
                    field: 'content',
                    cellRenderer: 'CellRendererContentClass',
                    width: 250,
                },
                {
                    headerName: this.$t('news.actions'),
                    field: 'actions',
                    width: 100,
                    cellRenderer: 'CellRendererActionsClass',
                },
            ],
            listNews: [],
            components: {
                CellRendererActionsClass,
                CellRendererContentClass,
            },
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            rowSelection: null,
            isSelected: false,
            dataSelected: [],
            dataMulti:[],
        }
    },
    created() {
        this.initScreen();
        this.rowSelection = "multiple"
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
                
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteNews'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NEWS', false);
            }
        },
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 1
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                if (this.gridApi) this.gridApi.paginationGoToPage(val - 1)
            }
        }
    },
    methods: {
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        deleteMulti() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ${this.dataSelected.length} thông báo đã chọn không ?`,
                accept: this.acptDeleteMulti,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        acptDeleteMulti(){
            this.$vs.loading();
            this.$crm.post(`/post-news-feed/deletes?postIds=${this.dataSelected}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Xóa thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.initScreen();
                this.isSelected = false;
            }).catch(error => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: error.response.data.message,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            });
        },
        onRowSelected(event) {
            this.isSelected = !!(event.api.getSelectedNodes().length > 0);
            if (this.isSelected) {
                this.dataSelected = event.api.getSelectedNodes().map(x => {
                    return x.data.id;
                })
            } else {
                this.dataSelected = [];
            }
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        addCamera() {
            this.$router.push('/user/manage-add-classroom-manager').catch(() => {
            })
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            this.$vs.loading();
            this.$crm.get('/post-news-feed/find-all').then((response) => {
                this.listNews = response.data.map(item => {
                    if (item.employeeDetailResponseDTO == null) {
                        item.employeeDetailResponseDTO = { fullName: 'Quản trị viên' };
                    }
                    return item
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024 && this.gridApi) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        setTimeout(() => {
            if (this.listNews.length < 1) {
                document.getElementsByClassName("ag-overlay-no-rows-center")[0].innerText = "Chưa có bài viết.";
            }
        }, 200);
    }
}
</script>

<style scoped></style>
